module.exports = __webpack_public_path__ + "img/logo_footer.7d1d299f.svg";